import { render, staticRenderFns } from "./SalePricesRuleForm.vue?vue&type=template&id=3f483cb2&scoped=true"
import script from "./SalePricesRuleForm.vue?vue&type=script&lang=js"
export * from "./SalePricesRuleForm.vue?vue&type=script&lang=js"
import style0 from "./SalePricesRuleForm.vue?vue&type=style&index=0&id=3f483cb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f483cb2",
  null
  
)

export default component.exports